import type { SortType } from '@components/table/hooks/useSort';

export interface Collection<T> {
  data: T[];
  total: number;
}

type AllowedValues = string | number | string[] | boolean | undefined;

type In<Keys extends string, Values extends AllowedValues> = {
  [key in Keys]: Values;
};

type Out<Keys extends string = string> = {
  [key in Keys | `${Keys}[${number}]`]: string | number | undefined;
};

export default function buildQueryFilters<K extends string, T extends AllowedValues, O extends Record<string, string>>(
  sort?: SortType,
  filters = {} as In<K, T>,
  otherFilters = {} as O,
): Out<K & string> {
  //
  // * Handle filters
  const old = Object.entries(filters) as [K, string | number | string[] | undefined][];
  const newFilters = {} as Out;

  old.forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v, i) => {
        if (v !== undefined) {
          newFilters[`${key}[${i}]`] = v;
        }
      });
      return;
    }
    if (value !== undefined) {
      newFilters[key] = value;
    }
  });
  // * --

  // * Handle sort
  if (sort?.sortKey && sort.sort) {
    newFilters[sort.sortKey] = sort.sort;
  }
  // * --

  return { ...newFilters, ...otherFilters };
}
